import { ApiError } from "../api/client";

// What the login page says when a sign-in fails. The Worker's login route
// answers most failures with a bare code and no message (`invalid_credentials`,
// the limiter's `rate_limited`), and on HTTP/2 `res.statusText` is "", so
// without this the page would show "unauthorized" or nothing at all. A message
// the Worker did write (the seat-cap refusal names who holds the seats) wins.
const COPY: Record<string, string> = {
  rate_limited:
    "Too many sign-in attempts from your connection. Give it a minute, then try again.",
  invalid_credentials: "That team name and password don't match.",
  network_error: "Can't reach Atlas. Check your connection and try again.",
};

export function loginErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const known = COPY[err.code];
    if (known !== undefined) return known;
    if (err.message.length > 0) return err.message;
    return `Sign-in failed (${err.code}).`;
  }
  if (err instanceof Error && err.message.length > 0) return err.message;
  return "Sign-in failed.";
}
